<template>
  <v-main>
    <v-container fluid>
      <v-row dense>
        <v-col cols="12">
          <v-card color="#1976d2">
            <v-card-title primary-title class="white--text">
              <div>
                <h3 class="headline mb-2">
                  Индивидуальные отчеты
                </h3>
              </div>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
      <v-row dense justify="center">
        <v-col cols="12" class="content">
          <v-card>
            <v-col cols="12">
              <v-row align="center" justify="center">
                <v-col>
                  <customers-combo-box
                    :multiple="true"
                    :value.sync="customers"
                    :selected-val="customers"
                    @clear="onClear(index)" />
                  <BaseAutoComplete
                    :items="customerGroupsList"
                    :value.sync="groupSelected"
                    @updateSelected="groupSelected=$event"
                    style="margin-left: 20px;"
                    label="Группа" />
                  <BaseControlElement :is-places-list="true"
                                      :lowest-date.sync="lowestDate"
                                      :highest-date.sync="highestDate"
                                      :places-selected.sync="placesSelected"
                                      :loading.sync="loading"
                                      @submitSearch="submitSearch" />
                </v-col>
              </v-row>
            </v-col>
          </v-card>
          <v-progress-linear v-show="loading" :indeterminate="true" />
        </v-col>
      </v-row>
      <v-row dense justify="center">
        <v-col v-for="(client, i) in filteredClients"
               :key="i"
               class="content"
               cols="12">
          <PersonDetailed :person="client" :products="products" />
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import BaseControlElement from '../../../base/BaseControlElement'
import PersonDetailed from './PersonDetailed'
import CustomersComboBox from '../../../base/CustomersComboBox'
import {mapState} from 'vuex'
import ReportsMixin from '../../new/ReportsMixinOld'
import BaseAutoComplete from '../../../base/BaseAutoComplete'


export default {
  name: "ReportPerPerson",
  components: {
    BaseControlElement,
    CustomersComboBox,
    PersonDetailed,
    BaseAutoComplete
  },
    mixins: [ReportsMixin],
  props: {
    report: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      customers:'',
      selectedYear: null,
      placesSelected: [],
      gendersSelected: [],
      groupSelected: [],
      genders: [],
      lowestDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10),
      highestDate: new Date().toISOString().substr(0, 10),
      loading: false
    }
  },
  computed: {
    ...mapState({
      clients: state => state.detailedReports.reports,
      products: state => state.tableData.products,
      customerGroupsList: state => state.tableData.customerGroups
    }),
    filteredClients () {
      let vm = this
      //console.log(this.clients)
      if (vm.groupSelected.length>0) return this.clients.filter(client => JSON.stringify(client.customergroups.map(e => e.id))===JSON.stringify(vm.groupSelected))
      return this.clients
    }
  },
  methods: {
    async submitSearch () {
      await this.$store.dispatch("detailedReports/updateReports",{
        codes: this.customers,
        placesSelected: this.placesSelected,
        gendersSelected: this.gendersSelected,
        groupSelected: this.groupSelected,
        lowestDate: this.lowestDate,
        highestDate: this.highestDate
      }).then(() => this.loading = false)
    }
  }
}
</script>

<style scoped>

.content {
  max-width: 800px;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/pages/ReportPerPerson/ReportPerPerson.vue